<template>
  <div class="single-select-setting">
    <label :for="resolvedId" class="single-select-setting-label">{{ label }}</label>
    <select :id="resolvedId" :value="modelValue" @change="handleChange">
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
    <div v-if="error" class="single-select-setting-error">{{ error }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, required: true },
  options: { type: Array, default: () => [] },
  error: { type: String, default: '' },
  inputId: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])

const resolvedId = computed(() => {
  if (props.inputId) return props.inputId
  return `single-select-${props.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`
})

function handleChange(event) {
  emit('update:modelValue', event.target.value || '')
}
</script>

<style scoped>
.single-select-setting {
  margin-bottom: 16px;
}

.single-select-setting-label {
  display: block;
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #495057;
}

.single-select-setting select {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  padding: 6px 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
}

.single-select-setting-error {
  margin-top: 6px;
  color: #dc3545;
  font-size: 13px;
}
</style>
